import { createApp } from 'vue'
import App from './App.vue'
import { vuetify } from './plugins'
import router from './router'
import store from './store';
import './assets/styles/mainLayout.scss'; // 스타일 파일을 import
import LodingComponent from './components/loading/LodingComponent.vue'
import { isPWA } from './utils/pwaDetector'

const app = createApp(App);

// 전역 컴포넌트 등록
app.component('LodingComponent', LodingComponent);

// PWA 모드 감지 및 store에 저장
const pwaMode = isPWA();
store.commit('setPWA', pwaMode);

// PWA 모드일 때 콘솔에 로그 출력 (개발용)
if (pwaMode) {
  // PWA 모드
} else {
  // 웹 브라우저 모드
}

app
.use(router)
.use(store) 
.use(vuetify)
.mount('#app')
